import { render, staticRenderFns } from "./ChargeRule.vue?vue&type=template&id=05672b5e&scoped=true&"
import script from "./ChargeRule.vue?vue&type=script&lang=js&"
export * from "./ChargeRule.vue?vue&type=script&lang=js&"
import style0 from "./ChargeRule.vue?vue&type=style&index=0&id=05672b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05672b5e",
  null
  
)

export default component.exports